export const CLASSROOMS = "/api/classrooms"
export const CLASSROOM = "/api/classrooms/:param"
export const CLASSROOM_ACTIVATE = "/api/classroom/:param/activate"
export const CLASSROOM_DEACTIVATE = "/api/classroom/:param/deactivate"
export const CLASSROOM_DELETE = "/api/classroom/:param/delete"

export const EXPORT_CLASSROOM = "/api/classrooms/export"
export const IMPORT_CLASSROOM = "/api/classroom/import"
